import React from "react";

const Loading = () => {
	return (
		<div className="LoadingComponent h-full w-full flex items-center justify-center">
			o o o
		</div>
	);
};

export default Loading;
